import { useQuery } from '@tanstack/react-query';

import OrderApi from '../../../lib/api/order/OrderApi';
import { ORDER } from '../../../constants/queryKeys';

const useOrderConfirmsCheck = (payload = 0, options) => {
  return useQuery([...ORDER.PURCHASE_CONFIRMS_CHECK, payload], () => OrderApi.getOrderConfirms(payload), options);
};

export default useOrderConfirmsCheck;
